"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePayload;
var _utils = require("../../middleware/utils");
function calculateAge(day, month, year) {
  var dob = new Date(month + '/' + day + '/' + year);
  //calculate month difference from current date in time
  var diff_ms = Date.now() - dob.getTime();
  var age_dt = new Date(diff_ms);
  return Math.abs(age_dt.getUTCFullYear() - 1970);
}
function generatePayload(values) {
  var payload = {};

  /* istanbul ignore next */
  function setFieldIfExists(fieldName, value, forcedValue) {
    if (value !== '' && value !== undefined) {
      payload[fieldName] = value;
    } else if (forcedValue || forcedValue === 0 || forcedValue === null) {
      payload[fieldName] = forcedValue;
    }
  }

  // Start all REQUIRED general fields
  setFieldIfExists('contributionRate', (0, _utils.parseCurrencyString)(null, values.contributionPercent));
  setFieldIfExists('currentAge', calculateAge(values.birthDay, values.birthMonth, values.birthYear));
  setFieldIfExists('currentSalary', (0, _utils.parseCurrencyString)(null, values.annualPay));
  setFieldIfExists('currentSavings', (0, _utils.parseCurrencyString)(null, values.savings));
  setFieldIfExists('incomeGoalPercent', (0, _utils.parseCurrencyString)(null, values.incomeGoalPercent));
  setFieldIfExists('inflationRate', (0, _utils.parseCurrencyString)(null, values.inflationRate));
  setFieldIfExists('lifeExpectancy', (0, _utils.parseCurrencyString)(null, values.lifeExpectancy));
  setFieldIfExists('retirementAge', (0, _utils.parseCurrencyString)(null, values.retirementAge));
  setFieldIfExists('rorPostRetirement', (0, _utils.parseCurrencyString)(null, values.rorPostRetirement));
  setFieldIfExists('rorPreRetirement', (0, _utils.parseCurrencyString)(null, values.rorPreRetirement));
  setFieldIfExists('salaryGrowth', (0, _utils.parseCurrencyString)(null, values.salaryGrowth));
  // ssBenefit needs to explicitly be set to null, if the user has not entered anything
  // else take what the user entered
  if (values.ssBenefit == '') {
    payload.ssBenefit = 'NA';
  } else {
    setFieldIfExists('ssBenefit', (0, _utils.parseCurrencyString)(null, values.ssBenefit));
  }
  return payload;
}